module.exports = __webpack_public_path__ + "img/img_84.e132cd47.png";